import styled from "styled-components";

export const RegistrationContainer = styled.div`
  width: 100%;
  height: auto;
  text-align: center;

  h1 {
    margin: 0;
    padding: 2rem 2rem 1rem;

    strong {
      font-weight: 900;
      color: #fe7730;
    }
  }

  ul {
    text-align: left;
  }

  .error-summary {
    color: darkred;
  }
`;
